import { defineStore } from 'pinia'
import apiFetch from '@wordpress/api-fetch'

export const useCountriesStore = defineStore('countries', {
  state: () => ({
    countries: [],
    activeCountries: [],
  }),

  actions: {
    loadCountries(params = {}) {
      this.countries = [];

      try {
        const context = this;
        const query = new URLSearchParams();

        if (params.lang) {
          query.append('lang', params.lang);
        }

        apiFetch({
          path: `/wp-json/ebus/countries?${query.toString()}`,
        }).then((countriesData) => {
          context.countries = countriesData;
        });
      } catch (error) {
        console.log('Error: ', error);
      }
    },

    toggleCountry(countryCode) {
      const index = this.activeCountries.indexOf(countryCode);

      if (index === -1) {
        this.activeCountries.push(countryCode);
      } else {
        this.activeCountries.splice(index, 1);
      }
    },

    resetActiveCountries() {
      this.activeCountries = [];
    },
  },
})
